import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import parse from "html-react-parser";
import GetDepartment from "../shared/GetDepartment";
import Getjob from "../shared/GetJob";
import GetPtorReason from "../shared/GetPtorReason";
//import { jsPDF } from "jspdf";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;
const HOME_PAGE_LINK = process.env.REACT_APP_URL + "login";
function Export2Word(
  element,
  mekhraz,
  departmentsList,
  jobsList,
  mayor,
  filename = ""
) {
  let department = "";
  if (!departmentsList || departmentsList.length === 0) {
    department = "מחלקה לא מוגדרת";
  }
  const searchType1 = departmentsList.find(
    (dep) => dep.id === mekhraz.department
  );
  department = searchType1 ? searchType1.title : "מחלקה לא מוגדרת";

  let kfifoot = "";
  if (!jobsList || jobsList.length === 0) {
    department = "מחלקה לא מוגדרת";
  }
  const searchType2 = jobsList.find((dep) => dep.id === mekhraz.kfifoot);
  kfifoot = searchType2 ? searchType2.title : "מחלקה לא מוגדרת";

  let job = "";
  if (!jobsList || jobsList.length === 0) {
    job = "מחלקה לא מוגדרת";
  }
  const searchType3 = jobsList.find((dep) => dep.id === mekhraz.job);
  job = searchType3 ? searchType3.title : "מחלקה לא מוגדרת";
  let mkh_type_word;

  if (mekhraz.mkh_type === "פטור") {
    mkh_type_word = "מודעה";
  } else if (mekhraz.mkh_type === "פנימי") {
    mkh_type_word = "מכרז פנימי";
  } else {
    mkh_type_word = "מכרז פומבי"; // Default value if `mekhraz.mkh_type` doesn't match "a" or "b"
  }

  const preHtml =
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  const postHtml = "</body></html>";

  const body2 = `<p dir="RTL" style="text-align: center; font-size: 18px;"><b>${mkh_type_word}  מספר ${
    mekhraz.mkh_num
  } <b></p>
  <p dir="RTL" style="text-align: center; font-size: 18px;">סוג המכרז- ${
    mekhraz.mkh_type
  }-</p>
  <p dir="RTL" style="text-align: center; font-size: 18px;"> ${
    mekhraz.title
  }</p>
  <p dir="RTL" style="text-align: center; font-size: 18px;">תאריך ההגשה עד-   ${
    mekhraz.hagsha_date
  }</p>
  ${
    mekhraz.prefix ? `<div align="right" dir="RTL">${mekhraz.prefix}</div>` : ""
  }

  <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:center;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span dir="LTR" style="font-size:15px;color:black;">&nbsp;</span></p>
  <div align="right" dir="rtl" style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;text-align:right;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;'>
      <table dir="rtl" style="border: none;border-collapse:collapse;">
          <tbody>
              <tr>
                  <td style="width: 88.85pt;border: 1pt solid windowtext;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>כפיפות</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${kfifoot}</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>תקן</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${job}</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;'>אגף/מחלקה</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>
                     ${department}</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>היקף משרה</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.ahoz_mesra + "%"
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>מספר משרות</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.mesrot_num
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>דירוג ודרגה</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.dirog
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;'>תיאור&nbsp;תפקיד</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.title
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>עיקרי תפקיד</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.ekary_tafkid
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>השכלה</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.haskala
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>ניסיון מקצועי</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.nesion_mektsoey
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>ניסיון ניהולי</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.nesion_neholy
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>תצהיר בדבר היעדר הרשעות פליליות</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.reshom_plili ? "כן" : "לא"
                      }</span></p>
                  </td>
              </tr>
              <tr>
                  <td style="width: 88.85pt;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><strong><span style='font-size:15px;font-family:"David",sans-serif;color:black;background:white;'>דרישות נוספות</span></strong></p>
                  </td>
                  <td style="width: 325.95pt;border-top: none;border-left: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-right: none;padding: 0cm 5.4pt;vertical-align: top;">
                      <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;text-align:right;line-height:normal;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Arial",sans-serif;'>${
                        mekhraz.drishot_nosafot
                      }</span></p>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <p dir="RTL">הגשת מועמדות -באמצעות  <a href=${HOME_PAGE_LINK}>מערכת המכרזים הדיגיטלית</a></p>
  ${
    mekhraz.reshom_plili
      ? '<p dir="RTL"> &nbsp; &nbsp;חובה להגיש אישור משטרה על העדר תביעות מיניות ובנוסף:.</p>'
      : "חובה להגיש:"
  }
  ${mekhraz.suffix ? `<p dir="RTL">${mekhraz.suffix}</p>` : ""}

  <p dir="RTL" style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;text-align:right;line-height:107%;font-size:15px;font-family:"Calibri",sans-serif;'><span dir="LTR">&nbsp;</span></p>
 
  <div dir="RTL">
  <p dir="RTL" style="text-align: center;"><strong></strong><br></p>
  <p dir="RTL" style="text-align: center;"><strong>&nbsp;</strong></p>
  <p dir="RTL" style="text-align: center;"><strong>&nbsp;בברכה&nbsp;</strong></p>
  <p dir="RTL" style="text-align: center;"><strong>${
    mayor?.full_name
  }</strong></p>
  <p dir="RTL" style="text-align: center;"><strong>ראש העיר</strong></p> </div>`;

  let html =
    preHtml + document.getElementById(element).innerHTML + body2 + postHtml;
  html = html.replace("עוברים לרשימת המכרזים (מסך ראשי)", "");

  const blob = new Blob(["\ufeff", html], {
    type: "application/msword",
  });
  // Specify link url
  const url =
    "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

  // Specify file name
  filename = filename ? filename + ".doc" : "document.doc";

  // Create download link element
  const downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // Create a link to the file
    downloadLink.href = url;

    // Setting the file name
    downloadLink.download = filename;

    // triggering the function
    downloadLink.click();
  }

  document.body.removeChild(downloadLink);
}

export default function Details(props) {
  const { visible, mekhraz, id, departmentsList, jobsList, ptorReasonsList } =
    props;

  const history = useNavigate();
  const [error, setError] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [ptorReasons, setPtorRreasons] = useState([]);
  const [mkhOptions, setMkhOptions] = useState();
  const [mayor, setMayor] = useState();
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getDepartments = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "department/", {
          signal: controller.signal,
        });
        isMounted && setDepartments(response.data);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };

    const getMkhTypes = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mkhtype/", {
          signal: controller.signal,
        });
        isMounted && setMkhOptions(response.data[0].mkhOptions);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };
    const getPtorReasons = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "ptorreason/", {
          signal: controller.signal,
        });
        isMounted && setPtorRreasons(response.data);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };
    const getDJobs = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "job/", {
          signal: controller.signal,
        });
        isMounted && setJobs(response.data);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };

    const getMayor = async () => {
      try {
        const mayorId = mekhraz.mayor ?? 0;
        const response = await axiosPrivate.get(baseURL + "mayor/" + mayorId, {
          signal: controller.signal,
        });
        isMounted && setMayor(response.data);
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getDepartments();
    getDJobs();
    getPtorReasons();
    getMkhTypes();
    getMayor();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const submitCopy = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const mekhrazCopy = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "copymekhraz/" + id + "/",
          mekhraz,
          {
            signal: controller.signal,
          }
        );

        //isMounted && setMekhrazUpdated((prevState) => !prevState);
        alert("מכרז חדש נוצר בהצלחה-מספר המכרז הוא 9999-");
      } catch (err) {
        if (err.response) {
          alert(
            HandleHttpErrors(err.response.status) +
              " או קיים מכרז מועתק שלא קבל מספר חדש! "
          );
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    mekhrazCopy();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  /* const exportPDF = () => {
    const doc = new jsPDF();
    const str = "<h3> פרטי המכרז</h3>";
    doc.text(str, 10, 10);
    doc.save("a4.pdf");
  };*/
  const handleExport = () => {
    Export2Word("exportContent", mekhraz, departmentsList, jobsList, mayor); // Replace "elementId" with the actual ID of the element you want to export
  };

  if (!visible) return;
  return (
    <Container
      style={{
        height: "calc(100vh - 40px)",
        overflowY: "scroll",
      }}
    >
      <div style={{ display: "none" }} id="exportContent">
        <p dir="rtl">עוברים לרשימת המכרזים (מסך ראשי)</p>
      </div>
      <Card className="success container px-5 " bg="light">
        <Card.Header className="mx-auto">
          <center>
            <h3> פרטי המכרז</h3>
            <Button type="submit" variant="primary" onClick={submitCopy}>
              העתקת המכרז למכרז חדש
            </Button>
            <Button
              type="submit"
              variant="primary"
              style={{ marginRight: "15px" }}
              onClick={handleExport}
            >
              יצוא המכרז ל WORD
            </Button>
          </center>
        </Card.Header>
        <Card.Body>
          <form>
            <Container className="col-sm-10">
              <Row>
                <Col>
                  <div>
                    <label htmlFor="canceled">האם המכרז בוטל?</label>
                    <br />
                    <input
                      readOnly
                      type="checkbox"
                      id="canceled"
                      name="canceled"
                      checked={mekhraz.canceled}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="text1">מספר המכרז</label>
                  <div className="form-control"> {mekhraz.mkh_num}</div>
                </Col>
                <Col>
                  <label htmlFor="title">תאור </label>
                  <div className="form-control">{mekhraz.title}</div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <label htmlFor="job">תפקיד</label>{" "}
                  <div className="form-control">
                    <Getjob jobsList={jobsList} jobIndex={mekhraz.job} />
                  </div>
                </Col>
                <Col>
                  <label htmlFor="kfifoot">כפיפות</label>{" "}
                  <div className="form-control">
                    <Getjob jobsList={jobsList} jobIndex={mekhraz.kfifoot} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div>
                    <label>סוג</label>
                    <div className="form-control"> {mekhraz.mkh_type}</div>
                  </div>
                </Col>

                <Col>
                  <label htmlFor="ptor_reason">סיבת הפטור</label>{" "}
                  <div className="form-control">
                    <GetPtorReason
                      ptorReasonsList={ptorReasonsList}
                      ptorIndex={mekhraz.ptor_reason}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="department"> מחלקה</label>{" "}
                  <div className="form-control">
                    <GetDepartment
                      departmentsList={departmentsList}
                      depIndex={mekhraz.department}
                    />
                  </div>
                </Col>
                <Col>
                  <label htmlFor="yeood_mesra">ייעוד משרה</label>
                  <div className="form-control">{mekhraz.yeood_mesra}</div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="mesrot_num">מספר המשרות המוצעות</label>
                  <div className="form-control">{mekhraz.mesrot_num}</div>
                </Col>
                <Col>
                  <label htmlFor="ahoz_mesra">אחוז כל משרה בממוצע</label>
                  <div className="form-control">{mekhraz.ahoz_mesra}</div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="persom_date">תאריך פרסום</label>
                  <div className="form-control">{mekhraz.persom_date}</div>
                </Col>
                <Col>
                  <label htmlFor="hagsha_date">תאריך הגשה אחרון</label>
                  <div className="form-control">{mekhraz.hagsha_date}</div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="dirog">דירוג</label>
                  <div className="form-control">{mekhraz.dirog}</div>
                </Col>

                <Col>
                  <div>
                    <label htmlFor="reshom_plili">
                      תצהיר בדבר היעדר הרשעות פליליות?
                    </label>
                    <br />
                    <input
                      type="checkbox"
                      id="reshom_plili"
                      name="reshom_plili"
                      checked={mekhraz.reshom_plili}
                      readOnly
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="prefix">
                    רישא-תופיע אחרי שם ומספר המכרז-
                  </label>
                  <div className="form-control">
                    {parse(mekhraz.prefix ? mekhraz.prefix : "")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="ekary_tafkid">עיקרי התפקיד</label>
                  <div className="form-control">
                    {parse(mekhraz.ekary_tafkid ? mekhraz.ekary_tafkid : "")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="haskala">דרישות השכלה</label>
                  <div className="form-control">
                    {parse(mekhraz.haskala ? mekhraz.haskala : "")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="nesion_mektsoey">דרישות נסיון מקצועי</label>
                  <div className="form-control">
                    {parse(
                      mekhraz.nesion_mektsoey ? mekhraz.nesion_mektsoey : ""
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <label htmlFor="nesion_neholy">דרישות נסיון ניהולי</label>
                  <div className="form-control">
                    {parse(mekhraz.nesion_neholy ? mekhraz.nesion_neholy : "")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="drishot_nosafot">דרישות נוספות</label>
                  <div className="form-control">
                    {parse(
                      mekhraz.drishot_nosafot ? mekhraz.drishot_nosafot : ""
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="suffix">
                    סיפא-תופיע לפני הצגת שם החתום על המכרז-
                  </label>
                  <div className="form-control">
                    {parse(mekhraz.suffix ? mekhraz.suffix : "")}
                  </div>
                </Col>
              </Row>
              <br></br>
            </Container>
          </form>
        </Card.Body>
      </Card>
    </Container>
  );
}
